import React, {useState, useEffect, useContext} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, Input} from 'reactstrap';
import {toast} from 'react-toastify';
import {changeUserLimits} from 'utils/api';
import {ErrorContext} from 'contexts/ErrorContext';
import SpinnerButton from 'components/SpinnerButton';

//import './style.scss';

function OrgLimitsModal({isOpen, toggle, orgId, settings, refreshList, itemName}) {
    const {handleErrors} = useContext(ErrorContext);

    const [dataLoading, setDataLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [webLimit, setWebLimit] = useState(0);
    const [twitterLimit, setTwitterLimit] = useState(0);
    const [facebookLimit, setFacebookLimit] = useState(0);
    const [rssLimit, setRssLimit] = useState(0);
    const [instagramLimit, setInstagramLimit] = useState(0);
    const [youtubeLimit, setYoutubeLimit] = useState(0);
    const [googleOzmosysLimit, setGoogleOzmosysLimit] = useState(0);

    useEffect(() => {
        if(settings) {
            setFacebookLimit(settings.facebookLimit || 0);
            setRssLimit(settings.rssLimit || 0);
            setInstagramLimit(settings.instagramLimit || 0);
            setYoutubeLimit(settings.youtubeLimit || 0);
            setTwitterLimit(settings.twitterLimit || 0);
            setWebLimit(settings.webLimit || 0);
            setGoogleOzmosysLimit(settings.googleOzmosysLimit || 0);
        }
    }, [settings]);

    const submitLimits = async() => {
        setSubmitting(true);
        let params = {
            webLimit: parseInt(webLimit),
            facebookLimit: parseInt(facebookLimit),
            twitterLimit: parseInt(twitterLimit),
            rssLimit: parseInt(rssLimit),
            youtubeLimit: parseInt(youtubeLimit),
            instagramLimit: parseInt(instagramLimit),
            googleOzmosysLimit: parseInt(googleOzmosysLimit)
        };
        try {
            await changeUserLimits(orgId, params);
            refreshList(true);
            setSubmitting(false);
            toast.success('Limits successfully updated');
            toggle();
        } catch(err) {
            // toast.error(err.message);
            // console.log('error: ', err);
            setSubmitting(false);
            handleErrors(err);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false} centered={true}>
            <ModalHeader toggle={toggle}>
                <strong>Edit Organization Limit</strong>
                <div style={{color: 'gray'}}>{itemName}</div>
            </ModalHeader>
            <ModalBody>
                {dataLoading ?
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <i className="fa fa-spinner fa-spin"/>
                    </div>
                    :
                    <div>
                        <div className="mb-2" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{padding: '0 10px', width: '120px'}}>Twitter</div>
                            <Input
                                style={{height: '35px', width: '150px'}}
                                onChange={(e) => setTwitterLimit(+e.target.value)}
                                value={twitterLimit}
                                type="number"
                                className="searchInput"
                            />
                        </div>
                        <div className="mb-2" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{padding: '0 10px', width: '120px'}}>Facebook</div>
                            <Input
                                style={{height: '35px', width: '150px'}}
                                onChange={(e) => setFacebookLimit(+e.target.value)}
                                value={facebookLimit}
                                type="number"
                                className="searchInput"
                            />
                        </div>
                        <div className="mb-2" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{padding: '0 10px', width: '120px'}}>Youtube</div>
                            <Input
                                style={{height: '35px', width: '150px'}}
                                onChange={(e) => setYoutubeLimit(+e.target.value)}
                                value={youtubeLimit}
                                type="number"
                                className="searchInput"
                            />
                        </div>
                        <div className="mb-2" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{padding: '0 10px', width: '120px'}}>Instagram</div>
                            <Input
                                style={{height: '35px', width: '150px'}}
                                onChange={(e) => setInstagramLimit(+e.target.value)}
                                value={instagramLimit}
                                type="number"
                                className="searchInput"
                            />
                        </div>
                        <div className="mb-2" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{padding: '0 10px', width: '120px'}}>RSS</div>
                            <Input
                                style={{height: '35px', width: '150px'}}
                                onChange={(e) => setRssLimit(+e.target.value)}
                                value={rssLimit}
                                type="number"
                                className="searchInput"
                            />
                        </div>
                        <div className="mb-2" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{padding: '0 10px', width: '120px'}}>Google News</div>
                            <Input
                                style={{height: '35px', width: '150px'}}
                                onChange={(e) => setGoogleOzmosysLimit(+e.target.value)}
                                value={googleOzmosysLimit}
                                type="number"
                                className="searchInput"
                            />
                        </div>
                        <div className="mb-2" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{padding: '0 10px', width: '120px'}}>Feed Builder</div>
                            <Input
                                style={{height: '35px', width: '150px'}}
                                onChange={(e) => setWebLimit(+e.target.value)}
                                value={webLimit}
                                type="number"
                                className="searchInput"
                            />
                        </div>
                    </div>
                }
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    title="Save Changes"
                    submitting={submitting}
                    onClick={submitLimits}
                    minWidth="123.22px"
                />
                {/*<Button*/}
                {/*    style={{minWidth: '85px'}}*/}
                {/*    onClick={submitLimits}*/}
                {/*    className="btn typical-button"*/}
                {/*>*/}
                {/*    {submitLoading ?*/}
                {/*        <i className="fa fa-spinner fa-spin"/>*/}
                {/*        :*/}
                {/*        'Save Changes'*/}
                {/*    }*/}
                {/*</Button>*/}
            </ModalFooter>
        </Modal>
    );
}

export default OrgLimitsModal;